import React from "react";
import Loadable from "react-loadable";
// import addEvent from './Views/Events/AddEvent/addEvent';
// import ViewDetailsShowPlace from './Views/ShowPlaces/ViewDetailsHall/ViewDetailsHall';

function Loading() {
  return (
    <div className="loading">
      <div className="spinner-grow text-muted"></div>
      <div className="spinner-grow text-primary"></div>
      <div className="spinner-grow text-success"></div>
    </div>
  );
}
// Dashboard
const Dashboard = Loadable({
  loader: () => import("./Views/DashBoard/Admin/dashBoard"),
  loading: Loading,
});
// event Dashboard
const EventDashboard = Loadable({
  loader: () => import("./Views/DashBoard/Event/dashBoard"),
  loading: Loading,
});
// Cinema Dashboard
const CinemaDashboard = Loadable({
  loader: () => import("./Views/DashBoard/Cinema/dashBoard"),
  loading: Loading,
});
// Sharing app
// const SharingDriverApp = Loadable({
//     loader: () => import('./Views/DashBoard/Admin/ShareDriverApp'),
//     loading: Loading
// })
// const SharingClientApp = Loadable({
//     loader: () => import('./Views/DashBoard/Admin/ShareClientApp'),
//     loading: Loading
// })
// profile
const Profile = Loadable({
  loader: () => import("./Views/Profile/profile"),
  loading: Loading,
});
// Client
// const Client = Loadable({
//     loader: () => import('./Views/Clients/viewClient/viewclient'),
//     loading: Loading,
// });
// const AddClient = Loadable({
//     loader: () => import('./Views/Clients/AddClient/addclient'),
//     loading: Loading,
// });
// const EditClient = Loadable({
//     loader: () => import('./Views/Clients/EditClient/editclient'),
//     loading: Loading,
// });
// const ViewDetailsClient = Loadable({
//     loader: () => import('./Views/Clients/ViewDetailsClient/viewDetailsClient'),
//     loading: Loading,
// });

// Event
// const ViewEvents = Loadable({
//     loader: () => import('./Views/Events/Events/ViewEvent/ViewEvent'),
//     loading: Loading,
// });
// const AddEvent = Loadable({
//     loader: () => import('./Views/Events/Events/AddEvent/addEvent'),
//     loading: Loading,
// });
// const EditEvent = Loadable({
//     loader: () => import('./Views/Events/Events/EditEvent/EditEvent'),
//     loading: Loading,
// });
// const ViewDetailsEvent = Loadable({
//     loader: () => import('./Views/Events/Events/ViewEventDetails/ViewEventDetails'),
//     loading: Loading,
// });

// Cinema
// const Cinema = Loadable({
//     loader: () => import('./Views/Cinema/Cinema/ViewCinema/viewcinema'),
//     loading: Loading,
// });
// const AddCinema = Loadable({
//     loader: () => import('./Views/Cinema/Cinema/AddCinema/addcinema'),
//     loading: Loading,
// });
// const EditCinema = Loadable({
//     loader: () => import('./Views/Cinema/Cinema/EditCinema/editcinema'),
//     loading: Loading,
// });

// const CinemaDetails = Loadable({
//     loader: () => import('./Views/Cinema/Cinema/CinemaDetails/CinemaDetails'),
//     loading: Loading,
// });
// Film Type

// const Type = Loadable({
//     loader: () => import('./Views/FilmTypes/viewFilmType/viewfilmType'),
//     loading: Loading,
// });
// const AddType = Loadable({
//     loader: () => import('./Views/FilmTypes/AddFilmType/addfilmType'),
//     loading: Loading,
// });
// const EditType = Loadable({
//     loader: () => import('./Views/FilmTypes/EditFilmType/editfilm'),
//     loading: Loading,
// });
// Film
const Movies = Loadable({
    loader: () => import('./Views/Films/viewFilm/viewfilm'),
    loading: Loading,
});

const ViewDetailsFilm = Loadable({
    loader: () => import('./Views/Films/ViewFilmDetails/viewDetailsFilm'),
    loading: Loading,
});

const cinemaMovies = Loadable({
    loader: () => import('./Views/Cinema/Cinema-Films/viewCinemaFilm/viewcinemafilm'),
    loading: Loading,
});

const ViewDetailsCinemaFilm = Loadable({
    loader: () => import('./Views/Cinema/Cinema-Films/ViewCinemaFilmDetails/viewDetailsCinemaFilm'),
    loading: Loading,
});

// ReportFilteration

const ReportFilteration = Loadable({
    loader: () => import('./Views/Reports/reports'),
    loading: Loading,
});
const ReportCreation = Loadable({
    loader: () => import('./Modules/Reports/report_Create'),
    loading: Loading
})

const Loginpage = Loadable({
    loader: () => import('./Views/Auth/UsersLogin/UsersLogin'),
    loading: Loading,
});

const ViewShows = Loadable({
    loader: () => import('./Views/Cinema/Shows/ViewShow/ViewShow'),
    loading: Loading,
});

const AddShow = Loadable({
    loader: () => import('./Views/Cinema/Shows/AddShow/AddShow'),
    loading: Loading,
});
const EditShow = Loadable({
    loader: () => import('./Views/Cinema/Shows/EditShow/EditShow'),
    loading: Loading,
});

const ViewDetailsShowCinema = Loadable({
    loader: () => import('./Views/Cinema/Shows/ViewDetailsShow/ViewDetailsShow'),
    loading: Loading,
});

//Event Shows

const ViewShowsEvent = Loadable({
    loader: () => import('./Views/Events/Shows/ViewShow/ViewShow'),
    loading: Loading,
});
const AddShowEvent = Loadable({
    loader: () => import('./Views/Events/Shows/AddShow/AddShow'),
    loading: Loading,
});
const EditShowEvent = Loadable({
    loader: () => import('./Views/Events/Shows/EditShow/EditShow'),
    loading: Loading,
});
const ViewDetailsShowEvent = Loadable({
    loader: () => import('./Views/Events/Shows/ViewDetailsShow/ViewDetailsShow'),
    loading: Loading,
});

// Show Places
const ViewHall = Loadable({
  loader: () => import("./Views/Halls/ViewHall/ViewHall"),
  loading: Loading,
});
const AddHall = Loadable({
  loader: () => import("./Views/Halls/AddHall/AddHall"),
  loading: Loading,
});
const EditHall = Loadable({
  loader: () => import("./Views/Halls/EditHall/EditHall"),
  loading: Loading,
});
const ViewDetailsCinemaHall = Loadable({
  loader: () => import("./Views/Halls/ViewDetailsHall/ViewDetailsHall-cinema"),
  loading: Loading,
});
const ViewDetailsEventHall = Loadable({
  loader: () => import("./Views/Halls/ViewDetailsHall/ViewDetailsHall-event"),
  loading: Loading,
});
const AddHallChairs = Loadable({
    loader: () => import('./Views/Chairs/AddChairs/AddChairs'),
    loading: Loading,
});
const EditHallChairs = Loadable({
    loader: () => import('./Views/Chairs/EditChairs/editOneChair'),
    loading: Loading,
});
const EditAllHallChairs= Loadable({
  loader: () => import('./Views/Chairs/EditChairs/EditChairs'),
  loading: Loading,
});
// Tickets
const ViewTickets = Loadable({
  loader: () => import("./Views/Tickets/ViewTicket/ViewTicket"),
  loading: Loading,
});
const AddTicket = Loadable({
  loader: () => import("./Views/Tickets/AddTicket/AddTicket"),
  loading: Loading,
});
const EditTicket = Loadable({
  loader: () => import("./Views/Tickets/EditTicket/EditTicket"),
  loading: Loading,
});


// Reservations Cineam

const ViewReservationCinema = Loadable({
    loader: () => import('./Views/Cinema/Reservations/ViewReservations/ViewReservations'),
    loading: Loading,
});

const ViewDetailsReservationCinema = Loadable({
    loader: () => import('./Views/Cinema/Reservations/ViewDetailsReservation/ViewDetailsReservation'),
    loading: Loading,
});

// Reservations Event
const ViewReservationEvents = Loadable({
    loader: () => import('./Views/Events/Reservations/ViewReservations/ViewReservations'),
    loading: Loading,
});

const ViewDetailsReservationEvents = Loadable({
    loader: () => import('./Views/Events/Reservations/ViewDetailsReservation/ViewDetailsReservation'),
    loading: Loading,
});
const ViewCashier = Loadable({
  loader: () => import('./Views/Cashier/viewCashier/viewCashier'),
  loading: Loading,
});
const AddCashier = Loadable({
  loader: () => import('./Views/Cashier/AddCashier/addCashier'),
  loading: Loading,
});
const EditCashier = Loadable({
  loader: () => import('./Views/Cashier/EditCashier/editCashier'),
  loading: Loading,
});
const EventAccounting = Loadable({
  loader: () => import('./Views/Events/Accounting/Accounting'),
  loading: Loading,
});
const CinemaAccounting= Loadable({
  loader: () => import('./Views/Cinema/Accounting/Accounting'),
  loading: Loading,
});
const ViewTicketsHistoryCinems= Loadable({
  loader: () => import('./Views/Cinema/TicketsHistory/ViewTicketsHistory/ViewTicketsHistory'),
  loading: Loading,
});
const TicketsHistoryCinemsDetails= Loadable({
  loader: () => import('./Views/Cinema/TicketsHistory/ViewDetailsTicketsHistory/ViewDetailsReservation'),
  loading: Loading,
});
const ViewTicketsHistoryEvent= Loadable({
  loader: () => import('./Views/Events/TicketsHistory/ViewTicketsHistory/ViewTicketsHistory'),
  loading: Loading,
});
const TicketsHistoryEventDetails= Loadable({
  loader: () => import('./Views/Events/TicketsHistory/ViewDetailsTicketsHistory/ViewDetailsReservation'),
  loading: Loading,
});
const CashierDetails = Loadable({
  loader: () => import('./Views/Cashier/ViewDetailsCashier/viewDetailsCashier'),
  loading: Loading,
});
const routes = [
  //ViewTicketsHistoryCinems
  { path: '/MyticketCinema/ViewTicketsHistoryCinems', exact: true, name: 'ViewTicketsHistoryCinems', component: ViewTicketsHistoryCinems },
  { path: '/MyticketCinema/TicketsHistoryCinemsDetails', exact: true, name: 'TicketsHistoryCinemsDetails', component: TicketsHistoryCinemsDetails },

    //ViewTicketsHistoryCinems
    { path: '/MyticketCinema/ViewTicketsHistoryEvent', exact: true, name: 'ViewTicketsHistoryEvent', component: ViewTicketsHistoryEvent },
    { path: '/MyticketCinema/TicketsHistoryEventDetails', exact: true, name: 'TicketsHistoryEventDetails', component: TicketsHistoryEventDetails },
  
  //Login page
  { path: '/MyticketCinema/login', exact: true, name: 'Loginpage', component: Loginpage },
  // Cashier
  { path: '/MyticketCinema/ViewCashier', exact: true, name: 'ViewCashier', component: ViewCashier },
  { path: '/MyticketCinema/AddCashier', exact: true, name: 'AddCashier', component: AddCashier },
  { path: '/MyticketCinema/EditCashier', exact: true, name: 'EditCashier', component: EditCashier },
  { path: '/MyticketCinema/CashierDetails', exact: true, name: 'CashierDetails', component: CashierDetails },
  // Dashboard
  {
    path: "/MyticketCinema/Dashboard",
    exact: true,
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/MyticketCinema/EventDashboard",
    exact: true,
    name: "Dashboard",
    component: EventDashboard,
  },
  {
    path: "/MyticketCinema/Cinema-dashboard",
    exact: true,
    name: "cinema dashboard",
    component: CinemaDashboard,
  },

  //Profile
  {
    path: "/MyticketCinema/profile",
    exact: true,
    name: "Dashboard",
    component: Profile,
  },
  //EventAccounting
  { path: '/MyticketCinema/EventAccounting', exact: true, name: 'EventAccounting', component: EventAccounting },
  //CinemaAccounting
  { path: '/MyticketCinema/CinemaAccounting', exact: true, name: 'CinemaAccounting', component: CinemaAccounting },
  //Cinema's Film
  { path: '/MyticketCinema/cinema-Films', exact: true, name: 'Films', component: cinemaMovies },
  { path: '/MyticketCinema/cinema-viewDetails-Film', exact: true, name: 'view Details Film ', component: ViewDetailsCinemaFilm },

  // Film
    { path: '/MyticketCinema/films', exact: true, name: 'Film', component: Movies },
    { path: '/MyticketCinema/viewDetails-Film', exact: true, name: 'view Details Film ', component:ViewDetailsFilm },

  //ReportFilteration

  { path: '/MyticketCinema/ReportFilteration', exact: true, name: 'ReportFilteration', component: ReportFilteration },
  { path: '/MyticketCinema/Create-Report', exact: true, name: 'Report Creation', component: ReportCreation },


  //Cinema Shows
  { path: '/MyticketCinema/shows', exact: true, name: 'shows', component: ViewShows },
  // { path: '/MyticketCinema/cinemaShows-admin', exact: true, name: 'shows', component: ViewShowsAdmin },
  { path: '/MyticketCinema/AddShow', exact: true, name: 'Add Show ', component: AddShow },
  { path: '/MyticketCinema/EditShow', exact: true, name: 'Edit Show ', component: EditShow },
  { path: '/MyticketCinema/viewDetails-ShowCinema', exact: true, name: 'View Details Show Cinema', component: ViewDetailsShowCinema },
  //Event Shows
  { path: '/MyticketCinema/event-shows', exact: true, name: 'shows', component: ViewShowsEvent },
  { path: '/MyticketCinema/AddShowEvent', exact: true, name: 'Add Show ', component: AddShowEvent },
  { path: '/MyticketCinema/EditShowEvent', exact: true, name: 'Edit Show ', component: EditShowEvent },
  { path: '/MyticketCinema/viewDetails-ShowEvent', exact: true, name: 'view Details Show ', component: ViewDetailsShowEvent },
  //Show Places
  {
    path: "/MyticketCinema/showHalls",
    exact: true,
    name: "shows places",
    component: ViewHall,
  },
  {
    path: "/MyticketCinema/AddHall",
    exact: true,
    name: "Add Show ",
    component: AddHall,
  },
  {
    path: "/MyticketCinema/EditHall",
    exact: true,
    name: "Edit Show ",
    component: EditHall,
  },
  {
    path: "/MyticketCinema/viewDetails-CinemaHall",
    exact: true,
    name: "view Details Show ",
    component: ViewDetailsCinemaHall,
  },
  {
    path: "/MyticketCinema/viewDetails-EventHall",
    exact: true,
    name: "view Details Show ",
    component: ViewDetailsEventHall,
  },
  { path: '/MyticketCinema/addChairs', exact: true, name: 'Associate Chair ', component: AddHallChairs },
  { path: '/MyticketCinema/editChairs', exact: true, name: 'Edit Chair ', component: EditHallChairs },
  
  { path: '/MyticketCinema/editAllChairs', exact: true, name: 'Edit Chair ', component: EditAllHallChairs },

  //Shows
  {
    path: "/MyticketCinema/Tickets",
    exact: true,
    name: "View Tickets",
    component: ViewTickets,
  },
  {
    path: "/MyticketCinema/AddTicket",
    exact: true,
    name: "Add Ticket ",
    component: AddTicket,
  },
  {
    path: "/MyticketCinema/EditTicket",
    exact: true,
    name: "Edit Ticket ",
    component: EditTicket,
  },

  // ReservationsCinema
  { path: '/MyticketCinema/ViewReservationCinema', exact: true, name: 'View resevationsCinema', component: ViewReservationCinema },
  { path: '/MyticketCinema/ViewDetailsReservationCinema', exact: true, name: 'Add Ticket ', component: ViewDetailsReservationCinema },

  // ReservationsEvents
  { path: '/MyticketCinema/ViewReservationEvent', exact: true, name: 'View Tickets', component: ViewReservationEvents },
  { path: '/MyticketCinema/ViewDetailsReservationEvent', exact: true, name: 'Add Ticket ', component: ViewDetailsReservationEvents },

];

export default routes;
